import React, { useEffect, useState } from "react";
import { Route, HashRouter as Router } from "react-router-dom";
import { Switch } from "react-router-dom";
import StickySidebar from "./layouts/StickySidebar";
import Employee_List from "./main/superadmin/Employee_List";
import Login from "./authentication/Login";
import Profile from "./pages/profile/Index";
import Page404 from "./pages/errorpages/404";
// import PurchaseTransaction from "./main/superadmin/OnDuty";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import LeaaveApplication from "./main/superadmin/LeaveApplication";
import Reimbursement from "./main/superadmin/Reimbursement";
// import OverTime from "./main/superadmin/Over_time";
import Attendance from "./main/superadmin/Attendance";
import Message from "./main/superadmin/Message";
import ProdectedRouter from './authentication/ProdectedRouter'
import LocationMaster from "./main/superadmin/LocationMaster";
import AttendanceDownload from "./main/superadmin/AttendanceDownload";

const AppContainer = () => {
  // const config = "/template/react";
  const [showStickySidebar, setShowStickySidebar] = useState(true);
  const location = useLocation();

  useEffect(() => {
    console.log = function () { };
    // Hide the sidebar on the "/invoices" page
    setShowStickySidebar(
      location.pathname !== "/invoice-one-a" &&
      location.pathname !== "/invoice-two" &&
      location.pathname !== "/invoice-three" &&
      location.pathname !== "/invoice-four-a" &&
      location.pathname !== "/invoice-five" &&
      location.pathname !== "/cashreceipt-1" &&
      location.pathname !== "/cashreceipt-2" &&
      location.pathname !== "/cashreceipt-3" &&
      location.pathname !== "/cashreceipt-4"
    );
  }, [location.pathname]);

  return (
    <Router basename="/">
      {showStickySidebar && <StickySidebar />}
      <Switch>
        <Route path="/login" exact component={Login} />
        <ProdectedRouter path="/profile" component={Profile} />
        <ProdectedRouter path="/" exact component={Employee_List} />
        <ProdectedRouter path="/Location-master" exact component={LocationMaster} />
        <ProdectedRouter path="/Leave-application" component={LeaaveApplication} />
        <ProdectedRouter path="/Reimbursement" component={Reimbursement} />
        {/* <ProdectedRouter path="/Over_time" component={OverTime} /> */}
        {/* <ProdectedRouter path="/On_duty" component={PurchaseTransaction} /> */}
        <ProdectedRouter path="/Attendance" component={Attendance} />
        <ProdectedRouter path="/Attendance-Download" component={AttendanceDownload} />
        <ProdectedRouter path="/message" component={Message} />
        <Route path="*" component={Page404} />
      </Switch>
    </Router>
  );
};

export default AppContainer;
